import React from "react"
import BottomBar from "../BottomBar/bottombar"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router"
import { Input } from "@fourkites/elemental-input"
import { RFIDCard } from "../../images"
import { RootState } from "store/store"
import "./RFID.css"
import { useTranslation } from "react-i18next"
import i18next from "i18next"

const RFID = (props: any) => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [RFIDCodeVal, setRFIDCodeVal] = useState("")
  const [disabledProceedRFID, setDisabledProceedRFID] = useState(true)
  const [invalidPhone, setinvalidPhone] = useState(false)

  const assetReducer = useSelector((state: RootState) => state.assetReducer)

  const setRFID = () => {
    let asset = {
      ...assetReducer.asset,
      RFIDCode: RFIDCodeVal
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    history.push("/asset-summary?mode=kiosk")
  }

  useEffect(() => {
    setRFIDCodeVal(assetReducer.asset.RFIDCode)
  }, [assetReducer.asset.RFIDCode])

  useEffect(() => {
    if (RFIDCodeVal.trim().length === 6) {
      setDisabledProceedRFID(false)
    } else {
      setDisabledProceedRFID(true)
    }
  }, [RFIDCodeVal])
  const trans = (key: string) => {
    return i18next.t(key) || ""
  }
  return (
    <>
      <div className="container">
        <div className="RFID-text">{t("enter_rfid_tag")}</div>
        <img className="RFID-card-image" src={RFIDCard} alt="RFID-card" />
        <div
          className={`driver-input driver-input-USDOT-font ${
            invalidPhone ? "error-label" : ""
          }`}
        >
          <Input
            autoFocus={true}
            className={`${invalidPhone ? "error-label" : ""}`}
            placeholder={trans("enter_rifd_tag_here")}
            label={""}
            value={RFIDCodeVal}
            onInput={e =>
              ((e.target as any).value = (e.target as any).value.slice(0, 6))
            }
            maxLength={6}
            onChange={event => setRFIDCodeVal(event.target.value)}
          />
        </div>
      </div>
      <BottomBar
        disabled={disabledProceedRFID}
        onClick={() => setRFID()}
        text={t("continue")}
      />
    </>
  )
}

export default RFID
